export const GET_VISITED_PROFILE = 'Home/GET_VISITED_PROFILE';
export const SET_VISITED_PROFILE = 'Home/SET_VISITED_PROFILE';
export const SET_FOLLOW = 'Home/SET_FOLLOW';